import React, { Component } from 'react';
import propTypes from 'prop-types';
import TextareaAutosize from 'react-autosize-textarea';

import { makeId } from 'utils/selectors';
import sharedStyles from 'app/shared.css';
import HelpIcon from './HelpIcon';

/**
 * render a simple text input
 */
export default class TextInput extends Component {
  static propTypes = {
    fieldContract: propTypes.shape({
      helpText: propTypes.string,
      minLength: propTypes.number,
      name: propTypes.string,
      regex: propTypes.string,
      required: propTypes.bool
    }).isRequired,
    isReadonly: propTypes.bool,
    onChange: propTypes.func.isRequired,
    selectedValue: propTypes.string,
    updateLocation: propTypes.string.isRequired,
    validationMessage: propTypes.string
  };

  static defaultProps = {
    isReadonly: false,
    selectedValue: '',
    validationMessage: undefined
  };

  constructor(props) {
    super(props);

    this.state = {};

    this.handleInputBlur = this.handleInputBlur.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    if (props.selectedValue !== state.selectedValue) {
      return {
        selectedValue: props.selectedValue || '',
        value: props.selectedValue || ''
      };
    }
    return null;
  }

  /**
   * call onChange prop with internal state value
   */
  handleInputBlur() {
    this.props.onChange(this.state.value);
  }

  /**
   * update internal state value
   * @param {string} e - event containing new value
   */
  handleInputChange(e) {
    this.setState({ value: e.target.value });
  }

  render() {
    const {
      fieldContract: { helpText, name, required },
      isReadonly,
      updateLocation,
      validationMessage
    } = this.props;
    const { value } = this.state;

    return (
      <div className="d-flex flex-column my-3">
        <span className="d-flex align-items-center font-weight-bold mb-2">
          {`${name}${required ? '*' : ''}`}
          {helpText && <HelpIcon id={makeId({ updateLocation })} message={helpText} />}
        </span>
        <TextareaAutosize
          className={`w-100 ${!validationMessage ? sharedStyles.valid : sharedStyles.invalid}`}
          disabled={isReadonly}
          onBlur={this.handleInputBlur}
          onChange={this.handleInputChange}
          data-test-id={makeId({ updateLocation })}
          value={value}
        />
        <span className={sharedStyles.fieldValidationMessage}>{validationMessage}</span>
      </div>
    );
  }
}
